<template>
  <pagination
    :prev="prev"
    :next="next"
    @next="setProject(nextProject)"
    @prev="setProject(prevProject)"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_CURRENT_PROJECT } from '@/store/mutation-types'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination
  },
  computed: {
    ...mapGetters(['nextProject', 'prevProject']),
    next () {
      return this.nextProject ? this.$t('nextProject') : ''
    },
    prev () {
      return this.prevProject ? this.$t('previousProject') : ''
    }
  },
  methods: {
    ...mapMutations({ setCurrentProject: SET_CURRENT_PROJECT }),
    ...mapActions(['fetchProject']),
    setProject (project) {
      if (!project) return
      const { id = -1 } = project

      this.fetchProject(id)
        .then(() => {
          this.$router.push({
            params: { id: project.slug ? `${ id }-${ project.slug }` : id }
          })
          return this.setCurrentProject(id)
        })
        .catch(() => {
          this.$router.push({ name: 'home' })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/DetailsPaginationContainer.vue